import { SettingsVerticalIcon } from 'components/icons/SettingsVertical'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { activeTools } from './hooks'
import classNames from 'classnames'

export const QATools = observer(function QATools() {
  const open = activeTools.enabled.get()
  const tools = activeTools.tools
  const [location, setLocation] = useState<'top-left' | 'top-right'>('top-left')

  useEffect(() => {
    // listen to shift-Q to toggle the QA tools
    const listener = (e: KeyboardEvent) => {
      // detect that we're not in an input field
      if (e.target instanceof HTMLInputElement) return
      if (e.target instanceof HTMLTextAreaElement) return

      if (e.key === 'Q' && e.shiftKey) {
        activeTools.toggle()
      }
    }

    document.addEventListener('keydown', listener)

    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [tools])

  if (tools.size === 0) return null

  const toolsArray = Array.from(tools).sort((a, b) => {
    return a[0].localeCompare(b[0])
  })

  return (
    <div
      className={classNames('fixed z-[9999] min-w-[300px]', {
        'left-0 top-0': location === 'top-left',
        'right-0 top-0': location === 'top-right',
      })}
    >
      <div
        className={classNames('flex max-h-full flex-col bg-white shadow-lg', {
          'rounded-br-xl': location === 'top-left',
          'rounded-bl-xl': location === 'top-right',
        })}
      >
        {!open && (
          <div
            className="flex cursor-pointer flex-row items-center gap-1 p-2 text-label-medium text-on-surface-var"
            onClick={() => activeTools.toggle()}
          >
            <SettingsVerticalIcon size={14} />
            Settings
          </div>
        )}
        {open && (
          <div className="flex max-h-screen flex-col flex-wrap text-body-medium">
            <div
              className="flex cursor-pointer flex-row items-center gap-1 p-2 text-label-medium text-on-surface-var"
              onClick={() => activeTools.toggle()}
            >
              <SettingsVerticalIcon size={14} />
              Settings
            </div>
            <a
              className="cursor-pointer p-2 hover:bg-gray-300"
              onClick={async () => {
                setLocation(location === 'top-left' ? 'top-right' : 'top-left')
              }}
            >
              Change Tools Corner
            </a>
            {toolsArray.map(([name, { label, callback }]) => {
              if (typeof label === 'string') {
                return (
                  <a
                    className="cursor-pointer p-2 hover:bg-gray-300"
                    key={name}
                    onClick={async () => {
                      const keepOpen = await callback()
                      if (keepOpen) return
                      activeTools.hide()
                    }}
                  >
                    {label}
                  </a>
                )
              }

              return <div key={name}>{label}</div>
            })}
          </div>
        )}
      </div>
    </div>
  )
})
